import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { facilitySchema } from "../shared";
import type { Facility } from "../types";

type FacilityModalProps = {
  initialValues: Facility;
  isModalOpen: boolean;
  setModalOpen(newValue: boolean): void;
  standList: string[];
  add(newValue: Facility): void;
};

export default function FacilityModal({
  initialValues,
  isModalOpen,
  setModalOpen,
  standList,
  add,
}: FacilityModalProps) {
  const formik = useFormik({
    initialValues,
    validationSchema: facilitySchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => add(values),
  });

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={isModalOpen}
      onClose={() => setModalOpen(false)}
    >
      <DialogTitle>Add Facility</DialogTitle>
      <DialogContent>
        <Box
          display="grid"
          gap={2}
          gridTemplateColumns="1fr"
          style={{ marginTop: "1rem" }}
        >
          <Autocomplete
            id="stationaryTestFacilityName"
            options={standList}
            renderInput={(params) => (
              <TextField {...params} label="Facility Name" size="small" />
            )}
            onChange={(_, v) => {
              formik.setFieldValue("stationaryTestFacilityName", v);
            }}
            value={formik.values.stationaryTestFacilityName}
            size="small"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button disabled={!formik.isValid} onClick={() => formik.submitForm()}>
          add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
